/**
 * Support Configuration
 * STORY-LEGAL-001: Centralized support contact information
 *
 * Single Source of Truth for all support-related strings.
 * Components should import from here instead of hardcoding emails.
 */

export const SUPPORT_CONFIG = {
  // Email addresses
  emails: {
    general: 'support@maestrograding.ai',
    returns: 'returns@maestrograding.ai',
    wholesale: 'wholesale@maestrograding.ai',
    privacy: 'privacy@maestrograding.ai',
  },

  // Support hours
  hours: {
    days: 'Mon-Fri',
    time: '9am-5pm PST',
    timezone: 'America/Los_Angeles',
  },

  // Response time expectations
  responseTime: {
    general: '1-2 business days',
    urgent: '24 hours',
  },

  // Physical address (for legal pages)
  address: {
    company: 'Muñoz Digital Media, LLC',
    // Note: Physical address should be added when business location is established
    // For now, online-only store
    type: 'online-only',
  },

  // Social media links
  social: {
    instagram: 'https://www.instagram.com/maestrograding/',
    facebook: 'https://www.facebook.com/profile.php?id=61588910140315',
    youtube: 'https://www.youtube.com/@MAESTROGRADING',
  },

  // Legal document metadata
  legal: {
    lastUpdated: '2026-01-06',
    jurisdiction: 'United States',
    governingLaw: 'California',
  },
};

// Helper function to get mailto link
export const getMailtoLink = (emailKey, subject = '') => {
  const email = SUPPORT_CONFIG.emails[emailKey] || SUPPORT_CONFIG.emails.general;
  const encodedSubject = subject ? `?subject=${encodeURIComponent(subject)}` : '';
  return `mailto:${email}${encodedSubject}`;
};

export default SUPPORT_CONFIG;
